import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import {
  allApiLinks,
  businessDetails,
  clearReducer,
  localLanguage,
  otpVerifiedDetails,
  userDetails,
} from '../auth/state/auth.actions';
import moment from 'moment';
import { GoogleEventsService } from 'src/app/shared/analyticservice/google-events.service';
import { AuthServicesService } from '../auth/services/auth-services.service';
import { NpsSurveyService } from '../click-it/nps-survey/nps-survey.service';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss', './terms-and-conditions.component.rtl.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false
})
export class TermsAndConditionsComponent implements OnInit {

  @Input() privacyPolicy: any;
  @Output() closePrivacyModal = new EventEmitter();
  isOpenDropDown = false;
  languages: any;
  languageToPrint: any;
  loading = false;
  showLoader = false;
  acceptButton = 'Agree';
  declineButton = 'Disagree';
  tempData: any;
  languageData: any;
  updatedDate: any = '2025-01-09';
  isAtBottom = false;
  slideAnimation = '';
  isTermsLoaded = false;
  constructor(
    private readonly authservice: AuthServicesService,
    private readonly router: Router,
    public translate: TranslateService,
    private readonly analyticService: GoogleEventsService,
    private readonly store: Store<any>,
    private readonly npsService: NpsSurveyService
  ) {
    this.store
      .select((state) => state)
      .subscribe((data) => {
        this.languageData = data.authReducer.localLanguage;
        console.log(this.languageData);
      });
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.isTermsLoaded = true
    }, 50);
    if (document.getElementsByTagName('body')[0].classList.contains('ltr')) {
      this.slideAnimation = "ltr";
    }
    else {
      this.slideAnimation = "rtl";
    }
    if (this.privacyPolicy) {
      this.showLoader = true;
      this.languageToPrint = this.languageData?.locale
        ?? 'English';
      this.getUserLanguages();
    }
  }

  @HostListener('document:click', ['$event'])
  clickout(event: MouseEvent) {
    if (this.isOpenDropDown) {
      this.isOpenDropDown = !this.isOpenDropDown;
    }
  }

  onClickOfBack() {
    this.router?.navigate(['login'])
  }

  getUserLanguages() {
    this.authservice.getUserLanguages().subscribe({
      next: (res) => {
        console.log(res);
        let language: any;
        res.forEach((val) => {
          console.log(val);
          if (val?.display_name === 'English') {
            language = val;
          }
        });
        this.languages = res;
        this.getPrivacyPolicy(language);
      },
      error: (err) => { },
    });
  }
  openDropdown(event: Event) {
    if (this.declineButton !== 'Loading...' || this.acceptButton !== 'Loading...') {
      event.stopPropagation();
      this.isOpenDropDown = !this.isOpenDropDown;
    }
  }

  getPrivacyPolicy(lang: any) {
    console.log('lang', lang);

    this.authservice.getTncprivatePolicy(lang.id).subscribe({
      next: (res) => {
        console.log(res);

        this.showLoader = false;
        if (res) {
          this.updatedDate = res?.updated_at;
          this.updatedDate = moment(this.updatedDate).format('MMMM DD, YYYY ');
          this.languageToPrint = lang?.display_name;
          this.privacyPolicy = res?.app_tnc;
          this.store.dispatch(
            localLanguage({
              language: lang,
            })
          );
          this.translate.use(lang?.locale.replace('-', ''));
        } else {
          this.translate.use('enEG');
        }
      },
      error: (err) => { },
    });
  }
  getLanguage(lang: any) {
    this.isOpenDropDown = false;
    this.languageToPrint = 'Loading...';
    this.getPrivacyPolicy(lang);
  }

  acceptPolicy() {
    if (this.isAtBottom) {
      this.store
        .select((state) => state)
        .subscribe((data) => {
          this.tempData = data.authReducer?.otpVerifiedDetails;
        });
      this.acceptButton = 'Loading...';
      this.loading = true;
      this.authservice.acceptPrivatePolicy().subscribe({
        next: (res) => {
          if (res.status) {
            let user = { ...this.tempData };
            user['tnc_accepted'] = true;
            this.store.dispatch(
              otpVerifiedDetails({
                otpVerfiedData: user,
              })
            );
            this.fetchApiLinks();
          }
        },
        error: (err) => { },
      });
      this.acceptButtonEvent();
    }

  }

  declinePolicy() {
    this.declineButton = 'Loading...';
    this.authservice.rejectPrivatePolicy().subscribe({
      next: (res) => {
        if (res.status) {
          this.npsService.stopHeartbeat();
          this.authservice.logout().subscribe({
            next: (res) => {
              this.store.dispatch(clearReducer());
              this.router.navigate(['login']);
            },
            error: (err) => { },
          });
        }
      },
      error: (err) => { },
    });
    this.declineButtonEvent()
  }

  fetchApiLinks() {
    this.authservice.fetchAllApiEndpoints().subscribe({
      next: (res) => {
        this.store.dispatch(
          allApiLinks({
            data: res._links,
          })
        );
        this.fetchUserDetails();
      },
      error: (err) => {
        this.loading = false;
        console.log(err);
      },
    });
  }

  fetchUserDetails() {
    this.authservice.fetchUserDetails().subscribe({
      next: (res) => {
        this.loading = false;
        this.store.dispatch(
          userDetails({
            data: res.data,
          })
        );
        this.store.dispatch(
          localLanguage({
            language: res.data.language,
          })
        );

        this.authservice
          .fetchBusinessDetails(res.data.default_business_id)
          .subscribe({
            next: (resDetails) => {
              this.router.navigate(['dashboard']);
              this.store.dispatch(
                businessDetails({
                  data: resDetails,
                })
              );
            },
            error: (err) => {
              console.log(err);
            },
          });
      },
      error: (err) => {
        this.loading = false;
        console.log(err);
      },
    });
  }

  closeModal() {
    this.closePrivacyModal.emit(null);
  }
  // onScroll(event: any): void {
  //   const element = event.target;
  //   // this.isAtBottom = element.scrollHeight - element.scrollTop === element.clientHeight;
  //   const isAtBottom = Math.abs(
  //     element.scrollHeight - element.scrollTop - element.clientHeight
  //   ) < 5; 
  //   console.log('Is at bottom:', isAtBottom);
  //   this.isAtBottom = isAtBottom;
  // }
  onScroll(event: any): void {
    const element = event.target;
    // Check if the user has reached the bottom
    const isAtBottom =
      Math.abs(element.scrollHeight - element.scrollTop - element.clientHeight) < 5;
    // Once scrolled to the bottom, keep the button enabled
    if (isAtBottom) {
      this.isAtBottom = true;
    }
  }
  // <---------- Google Analytics Events Starts  --------->
  acceptButtonEvent() {
    let action = 'AgreeClicked';
    let category = 'Setting Activity';
    let label = 'Click AgreeButton';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
  declineButtonEvent() {
    let action = 'DisagreeClicked';
    let category = 'Setting Activity';
    let label = 'Click DisagreeButton';
    let index = '';
    let value = '';
    this.analyticService.googleEvent(action, category, label, index, value);
  }
}
